import { LocaleId } from '@strings';

/**
 * KISS: Validate a locale value (if provided). Does NOT mutate or normalize.
 * Clients decide whether to keep/remove defaults or modify their settings objects.
 *
 * @param value The candidate locale value (may be undefined)
 * @param reportError Callback to record a validation error
 */
export function validateLocaleValue(
  value: unknown,
  reportError: (message: string) => void
): void {
  if (value === undefined) return; // Absent is fine
  if (typeof value !== 'string') {
    reportError('Invalid locale setting: must be string');
    return;
  }
  const allowed = new Set<string>(Object.values(LocaleId));
  if (!allowed.has(value)) {
    reportError(
      `Invalid locale setting: '${value}'. Expected one of: ${Array.from(allowed)
        .sort()
        .join(', ')}`
    );
  }
}
